<template>
	<div class="detailedList">
		<div class="videoOuter" v-show="showId"></div>
		<el-dialog :title="dialogListName" :close-on-click-modal=false :visible.sync="dialogListVisible" width="300px" :close="handleListClose" top="13vh">
			<div class="dialogMain">
				<ol>
					<li v-for="(list,index) in videoList" :key="index">
						<a href="javascript:void(0);" @click="play(list)">{{list.name}}</a>
					</li>
				</ol>
			</div>
			<span slot="footer" class="dialog-footer">
		    	<el-button @click="dialogListVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		<el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="500px" :close="handleClose" top="8vh">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">*</span>清单名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.name"  class="inputWidth" placeholder="清单名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>视频列表：</dt>
					<dd class="cf">
						<div class="cf">
							<span v-show="videoListArr.items.length==0">暂无视频列表</span>
							<span v-for="(list,i) in videoListArr.items" :key="i" :class="list.status==2?'translucence videoList fl':'videoList fl'">
								<a href="javascript:void(0);" @click="play(list)">{{list.name}}</a>
								<i href="javascript:void(0);" class="el-icon-circle-plus-outline addVideo" v-show="list.status!=2" @click="addVideoFn(list)"></i>
							</span>
						</div>
						<el-pagination
						  small
						  :current-page="videoListArr.currentPage"
						  layout="prev, pager, next"
						  :total="videoListArr.totalSize"
						  @current-change="handleListCurrentChange"
						  class="fr listPaging"
						  v-show="videoListArr.totalSize>10">
						</el-pagination>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>视频排序：</dt>
					<dd class="cf">
						<div class="sequence">
							<span v-show="checkList.length==0">无选视频</span>
							<span :class="active==index?'checkList active':'checkList'" v-for="(list,index) in checkList" @click="active=index" :key="index">
								{{list.name}}
								<i href="javascript:void(0);" class="el-icon-circle-close-outline deleteVideo" @click="deleteVideoFn(index)"></i>
							</span>
						</div>
						<div v-show="checkList.length>0">
							<el-button type="primary" size="mini" @click="zIndexUp(checkList,active,checkList.length)">上移</el-button>
							<el-button type="primary" size="mini" @click="zIndexDown(checkList,active,checkList.length)">下移</el-button>
						</div>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>是否激活：</dt>
					<dd class="cf">
						<el-switch
						  v-model="dialogData.activate"
						  active-color="#13ce66"
						  inactive-color="#ff4949">
						</el-switch>
					</dd>
				</dl>
				<dl>
					<dt>&ensp;清单描述：</dt>
					<dd class="cf">
						<el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述" ></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<div class="mainBody">
			<div >
				<el-input size="small" v-model="filtrateData.name" placeholder="清单名称" class="inputWidth1"></el-input>
				<el-select size="small" v-model="filtrateData.activate" placeholder="清单是否激活" class="inputWidth1">
					<el-option v-for="item in activateOptions" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-button type="primary" size="mini" @click="handleSearch()" class="searchBtn">查询</el-button>
				<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
			</div>
			<div class="filtrateMain">
				<el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
				<el-button type="danger" size="mini" @click="handleDelete()">删除</el-button>

			</div>
			<div class="isZero" v-show="tableData.length<=0">暂无清单</div>
			<el-row :gutter="20">
			  	<el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="4" v-for="(item,index) in tableData" :key="index">
		  	 		<div class="details">
						<div class="check">
							<el-checkbox @change="checkFn(item.id,index)" :class="'checked'+index"></el-checkbox>
							<!--<input type="checkbox" name="checkbox" @click="deleteFn(item.id)">-->
						</div>
						<div class="picHide">
							<div class="imgHide">{{item.name}}({{item.activate==1?'已激活':'未激活'}})</div>
						</div>
						<div class="cf remarkHide">
							{{item.description?'描述：'+item.description:'暂无描述'}}
							<div class="" v-show="!item.videoList">暂无视频{{item.videoList?item.videoList=item.videoList:item.videoList=[]}}</div>
							<ol>
								<li v-for="(list,index1) in item.videoList" :key="index1" :class="list.status==2?'translucence':''"><a href="javascript:void(0);" @click="play(list)">{{list.name}} 一一 {{getPictureDataNameById(list.imgListId)}}</a></li>
							</ol>
							<!--<div class="fr" v-show="item.videoList.length>5">
								<a href="javascript:void(0);" @click="videoListFn(item.name, item.videoList)">查看全部 ></a>
							</div>							-->
						</div>
						<div class="foot cf">
							<span class="dateTime fl">{{item.createTime}}</span>
							<a href="javascript:void(0)" class="el-icon-edit fr" @click="handleEdit(item)" style="color: #000;text-decoration: none;"></a>
						</div>
					</div>
			  	</el-col>
			</el-row>
		</div>
		<!--分页-->
		<div class="page">
			<el-pagination
				background
				:current-page="tableDataArr.currentPage"
				:page-sizes="[10,20,30,40]"
				:page-size="tableDataArr.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="tableDataArr.totalSize"
		     	@current-change="handleCurrentChange"
		     	@size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import management from './management.vue'
	import navZcy from './nav.vue'
	export default{
		data() {
			return {
				loading: false,
				dialogVisible: false,
				dialogTitle: '',
				dialogData: {},
				dialogListName: '',
				dialogListVisible: false,
				videoList: [],
				active: -1,
				checked: {},
				showId: false,
				filtrateData: {},
				tableDataArr: {			//分页
					currentPage: 1,
					pageSize: 10,
					totalSize: 0
				},
				filtrateData: {},
				tableData: [],
				checkList: [],
				videoListArr: {
					currentPage: 1,
					pageSize: 10,
					totalSize: 0,
					items: []
				},
				videoListTotal: 0,
				activateOptions: [{
					id: 1,
					name: "激活"
				},{
					id: 2,
					name: "未激活"
				}],
				pictureData:[],
			}
		},
		methods: {
			play: function(item){
				$('.el-dialog__wrapper').css('z-index','999')
				$('.v-modal').css('z-index','997')
				var div = '<div class="video" style="width: 990px;margin:0 auto;height: 70%;position: relative;"><video id="my-video" class="video-js vjs-big-play-centered" controls style="width: 100%;height:100%;" poster="'+item.imgUrl+'"><source src="'+item.videoUrl+'" type="video/mp4"><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that<a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p></video>'
				$('.videoOuter').prepend(div)
				$('.video').append('<a href="javascript:void(0)" class="closeBtn">×</a>')
				var videoId = 'my-video'
				var myPlayer = videojs(videoId)
				let vue = this
				$('.closeBtn').click(function(){
					vue.close()
				})
				this.showId = true
				videojs("my-video", {}, function() {
			       	var myPlayer = this;
		    	});
			},
			close: function(){
				$(".video").remove()
			  	this.showId = false
				var myPlayer = videojs('my-video')
				myPlayer.pause();
			},
			videoListFn: function(name, list) {
				this.dialogListName = name
				this.videoList = list
				this.dialogListVisible = true
			},
			handleListClose: function(done) {
				done();
			},
			handleClose: function(done) {
				this.loading = false
				done();
			},
			inquiryVideo: function(){
				var data = {
					currentPage: this.videoListArr.currentPage,
					pageSize: this.videoListArr.pageSize
				}
				this.$http.post("zcvrVideoApi/video/inquiryVideo/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
		  			(success)=>{
		  				console.log(success)
		  				if(success.body.msg!="ok"){
							this.$message({
								type: 'error',
								message: success.data.msg
							});
							if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}else {
		  					this.videoListArr = success.body.data
		  					if(!this.videoListArr.items){
		  						this.videoListArr.items = []
		  					}
		  				}
		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			inquiryDetailedList: function(){
				var data = {
					name: this.filtrateData.name==undefined?this.filtrateData.name:this.filtrateData.name.trim(),
					activate: this.filtrateData.activate,
					currentPage: this.tableDataArr.currentPage,
					pageSize: this.tableDataArr.pageSize
				}
				this.$http.post("zcvrVideoApi/detailedList/inquiryDetailedList/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
		  			(success)=>{
		  				console.log(success)
		  				if(success.body.msg!="ok"){
		  					this.tableData = []
							this.$message({
								type: 'error',
								message: success.data.msg
							});
							if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}else {
		  					this.tableDataArr = success.body.data
		  					if(this.tableDataArr.items){
		  						this.tableData = this.tableDataArr.items
		  					}else{
		  						this.tableData = []
		  					}
		  					console.log(this.tableData)
		  				}

		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			handleAdd: function() {
				this.loading=false
				this.dialogTitle = "新增清单"
				this.dialogData = {}
				this.checkList = []
				this.dialogVisible = true
			},
			handleEdit: function(item) {
				this.loading=false
				this.dialogTitle = "修改清单"
				this.dialogData = {
					id: item.id,
					name: item.name,
					description: item.description,
					activate: item.activate==1?true:false,
					videoList: item.videoList
				}
				this.checkList = [].concat(item.videoList)
				this.dialogVisible = true
			},
			handleConfirm: function() {
				console.log(this.checkList)
				var videoIds = []
				for (var i=0; i<this.checkList.length; i++) {
					videoIds.push(this.checkList[i].id)
				}
				this.loading=true
				var data = {
					name: this.dialogData.name==undefined?this.dialogData.name:this.dialogData.name.trim(),
					videoIds: videoIds,
					activate: this.dialogData.activate?1:2,
					description: this.dialogData.description
				}
				var url = ""
				if(!this.dialogData.id){
					url = "zcvrVideoApi/detailedList/createDetailedList/"+sessionStorage.getItem('sessionId')
				}else{
					data.id = this.dialogData.id
					url = "zcvrVideoApi/detailedList/updateDetailedList/"+sessionStorage.getItem('sessionId')
				}
				this.$http.post(url,data,{emulateJson:true}).then(
		  			(success)=>{
						this.loading=false
		  				console.log(success)
		  				if(success.data.msg=="ok"){
		  					this.dialogVisible = false
		  					this.inquiryDetailedList()
		  				}else {
		  					this.$message({
					          message: success.data.msg,
					          type: 'error'
					        });
			  				if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}
		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			handleSearch: function() {
				this.tableDataArr.currentPage = 1
				this.inquiryDetailedList()
			},
			handleReset: function(){
				this.filtrateData = {}
				this.inquiryDetailedList()
			},
			checkFn: function(id, index){
				var len = $('.checked'+index+'.is-checked').length
				if(len==1){
					this.checked[id] = false
				}else{
					this.checked[id] = true
				}
			},
			handleDelete: function() {
				var ids = []
				var checked = this.checked
				Object.keys(checked).forEach(function(key){
				    if(checked[key] == true){
				     	ids.push(key)
				    }
				});
				console.log(ids)
				if(ids.length>0){
					this.$confirm('此操作将永久删除该清单, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.get("zcvrVideoApi/detailedList/deleteDetailedList/"+sessionStorage.getItem('sessionId')+"/"+ids,{emulateJson:true}).then(
				  			(success)=>{
				  				console.log(success)
				  				if(success.body.msg=="ok"){
				  					this.$message({
							          message: '删除成功',
							          type: 'success'
							        });
							        this.checked = {}
				       				$('.el-checkbox__input.is-checked').removeClass('is-checked')
							        this.inquiryDetailedList()
				  				}else{
				  					this.$message({
							          message: success.data.msg,
							          type: 'error'
							        });
					  				if(success.data.msg=="该SessionId已经超时"){
							  			this.$message.error("登录超时！请重新登录");
							  			this.$router.push({path: '/',query: ''})
							  		}
				  				}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}else{
					this.$message({
						type: 'info',
						message: '请选择删除项'
					});
				}
			},
			addVideoFn(list) {
				this.checkList.push(list)
			},
			deleteVideoFn(index) {
				this.checkList.splice(index, 1);
			},
			swapArray(arr, index1, index2) {
			  	arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			    return arr;
			},
			//上移 将当前数组index索引与后面一个元素互换位置，向数组后面移动一位
			zIndexDown(arr,index,length){
				if(index!=-1){
					if(index+1 != length){
				   		this.active = index+1
				       	this.swapArray(arr, index, index+1);
				   	}else{
				   		this.$message({
							type: 'info',
							message: '已经处于置底顶，无法下移'
						});
				  	}
				}else{
					this.$message({
						type: 'info',
						message: '请选需下移项'
					});
				}

			},
			//下移 将当前数组index索引与前面一个元素互换位置，向数组前面移动一位
			zIndexUp(arr,index,length){
				if(index!=-1){
				   	if(index!= 0){
				   		this.active = index-1
				       	this.swapArray(arr, index, index-1);
				   	}else{
				   		this.$message({
							type: 'info',
							message: '已经处于置顶，无法上移'
						});
				    }
			   	}else{
			   		this.$message({
						type: 'info',
						message: '请选需上移项'
					});
			   	}
			},
			handleListCurrentChange(cur){
				this.videoListArr.currentPage = cur
				this.inquiryVideo()
			},
	        //点击页数
			handleCurrentChange(cur) {
				this.tableDataArr.currentPage = cur
				this.inquiryDetailedList()
			},
			//点击改变显示条目
			handleSizeChange(size) {
				this.tableDataArr.pageSize = size
				this.inquiryDetailedList()
			},
			inquiryImgList: function(){
				var data = {
					status:1,
					activate: 1,
					currentPage: 1,
					type:1,
					pageSize: 10000000
				}
				this.$http.post("zcvrVideoApi/imgList/inquiryImgList/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
						(success)=>{
							console.log(success)
							if(success.body.msg!="ok"){
								this.pictureData = []
								this.$message({
									type: 'error',
									message: success.data.msg
								});
								if(success.data.msg=="该SessionId已经超时"){
									this.$message.error("登录超时！请重新登录");
									this.$router.push({path: '/',query: ''})
								}
							}else {
								const tableDataArr = success.body.data
								if (tableDataArr){
									this.pictureData = tableDataArr.items;
								}else {
									this.pictureData = [];
								}
								console.log(this.pictureData)
							}

						},
						(error)=>{
							console.log("数据连接失败")
						}
				)
			},
			getPictureDataNameById(id){
				if (this.pictureData) {
					for (var i = 0;i<this.pictureData.length;i++){
						var item = this.pictureData[i];
						if (item.id == id){
							return item.name;
						}
					}
				}

			},
		},
		mounted(){
			this.inquiryVideo()
			this.inquiryImgList();
			this.inquiryDetailedList()
		},
		components: {
			management,
			navZcy
		}
	}
</script>

<style type="text/css">
	a.closeBtn{
		color: #fff;
		font-size: 42px;
	    position: absolute;
	    top: -8px;
		right: 10px;
	    opacity: .9;
	    text-decoration: none;
	}
	.el-dialog__header{
		border-bottom: 1px solid #eee;
	}
	/*.el-checkbox{
	    margin-left: 0 !important;
	    margin-right: 15px !important;
	}*/
</style>
<style scoped>
	/*公用的*/
	.fl{
		float: left;
	}
	.fr{
		float: right;
	}
	.cf{
		overflow: hidden;
	}
	.translucence{
		opacity: 0.5;
	}
	.translucence a{
		text-decoration: line-through !important;
	}
	.videoOuter{
		width: 100%;
    	height: 100%;
		position: fixed;
		top:0px;
		padding-top: 10%;
		z-index: 1000;
		background: rgba(0,0,0,0.5);
	}
	.video{
		display: inline-block;
		vertical-align: middle;
		width: 80%;
		height: 70%;
		margin: 0 auto;
	}
	.tooltip{
		padding-left: 10px;
	}
	.videoImg{
		width: 200px;
		height: 150px;
		cursor: pointer;
	}
	.videoList{
		padding: 0 10px;
		margin-right: 10px;
		margin-bottom: 10px;
		border: 1px solid #eee;
	}
	.addVideo,.deleteVideo{
		cursor: pointer;
	}
	.addVideo:hover{
		color: #67c23a;
	    border-color: #67c23a;
	}
	.deleteVideo:hover{
		color: #000;
	    border-color: #000;
	}
	.sequence{
		overflow: auto;
	    margin-bottom: 10px;
	    padding-bottom: 5px;
	}

	.sequence::-webkit-scrollbar{
		width: 16px;
		height: 10px;
		background-color: #F5F5F5;
	}
	.sequence::-webkit-scrollbar-track{
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
		background-color: #F5F5F5;
	}
	.sequence::-webkit-scrollbar-thumb{
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
		background-color: #555;
	}
	.checkList{
		cursor: pointer;
		padding: 10px;
		margin-right: 10px;
		white-space: nowrap;
		border: 1px solid #eee;
	}
	.checkList.active{
		color: #67c23a;
	    border-color: #67c23a;
	}
	.checkList:hover{
		color: #67c23a;
	    border-color: #67c23a;
	}
	.listPaging{
		line-height: 20px;
	}
	.mainBody{
		padding: 20px;
	}
	.filtrateMain{
		padding-top: 10px;
		padding-bottom: 20px;
	}
	.searchBtn{
		margin-left: 20px;
	}
	.inputWidth1{
		width: 150px;
	}
	.details{
		position: relative;
		margin-bottom: 20px;
		border: 1px solid #eee;
   		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
	}
	.isZero{
		text-align: center;
		padding: 50px;
	}
	.check{
		position: absolute;
		top: 0;
		right: 0;
		z-index: 10;
		background: #fff;
		padding: 0 5px;
	}
	.picHide{
		height: 70px;
		width: 100%;
		overflow: hidden;
		border-bottom: 1px solid #eee;
	}
	.picHide .imgHide{
		width:100%;
		padding: 10px 20px;
		background: #fff;
		color: #2a72c5;
		font-weight: bold;
		line-height: 25px;
		height: 70px;
		box-sizing: border-box;
	}
	.remarkHide{
		padding: 5px 20px;
		height: 155px;
		overflow-y: auto;
		overflow-wrap: break-word;
	}
	.mainBody ol{
		margin: 10px 0;
		padding-left: 25px;
	}
	.dialogMain ol{
		margin: 0;
	}
	.mainBody a, .dialogMain a{
		color: #000000;
		text-decoration: none;
	}
	.mainBody a:hover, .dialogMain a:hover{
		text-decoration: underline;
	}
	.foot{
		padding: 10px 15px;
		border-top: 1px solid #eee;
	}
	.dateTime{
	    color: #838383;
	    font-size: 10px;
	    line-height: 20px;
	    margin-bottom: 0px;
	}
	.page{
		text-align: center;
	}
</style>
